/*
 * @Description:
 * @Author: 山淑兰
 * @Date: 2019-12-26 10:32:28
 * @LastEditTime: 2020-07-16 22:06:02
 * @LastEditors: 山淑兰
 */

/**
 * Created by VULCAN on 2018/8/8.
 */
import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";
import _ from "lodash";
import Utils from "../utils/manageCode";
// import Qs from "qs";

const _axios = axios.create({
  // headers: {
  //   "Content-Type": "application/json;charset=UTF-8",
  // },
  // timeout: 30000,
  // transformRequest: [
  //   data => {
  //     return JSON.stringify(data);
  //   },
  // ],
});

_axios.interceptors.request.use(
  config => {
    const { path } = VUE.$route;
    if (path != "/liveInfo" && path != "/liveinfo") {
      let Authorization = "";
      try {
        if (path == "/elogin" || path == "/initPage") {
          Authorization = Cookies.get("wqExpertToken") || localStorage.getItem("wqExpertToken");
        } else {
          Authorization = Cookies.get("wqToken") || localStorage.getItem("wqToken");
        }
        if (Authorization) {
          config.headers.Authorization = Authorization;
        } else if (
          VUE.$route.path != "/schedules" &&
          VUE.$route.path != "/initPage" &&
          VUE.$route.path != "/elogin"
        ) {
          Utils.redirect("/transition");
        }
      } catch (error) {
        alert("当前浏览器处于无痕模式,请使用标准浏览器!");
        console.error(error);
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

_axios.interceptors.response.use(
  res => {
    let _data = null;
    if (res.status === 200) {
      _data = res.data;

      const { path } = VUE.$route;
      console.log(path);
      if (path != "/liveInfo" && path != "/liveinfo") {
        const toUrl = encodeURIComponent(window.location.href);
        if (_.isPlainObject(_data) && _data.Code) {
          switch (_data.Code) {
            // 会议未报名用户
            case 6003:
              if (path != "/elogin" && path != "/initPage") {
                Utils.redirect("/");
                break;
              }
            // 用户未验证手机号登录
            case 6001: {
              if (path != "/transition") {
                if (path == "/initPage") {
                  break;
                } else {
                  Utils.redirect("/login", { toUrl });
                }
              }
              break;
            }
            // 8001微信未授权登录;  2001未获取到数据标识
            case 8001:
              if (path != "/transition") {
                if (Utils.isPcWechat()) {
                  // PC 微信不走微信授权，视为未登录，引导短信验证码登录
                  Utils.redirect("/login", { toUrl });
                } else {
                  Utils.redirect("/transition", toUrl);
                }
              }
              break;
            case 2001:
              VUE.$message.error({ message: _data.Msg, customClass: "errorMessage" });
              break;
            // 本次会议已报名用户
            case 6004:
              if (path == "/" && _data.signUp_Set.jump_link) {
                console.log(_data.signUp_Set.jump_link);
              } else if (path != "/signup/addPersonnel") {
                Utils.redirect("/personalCenter");
              }
              break;
            //  6002，用户已登录并验证了手机号
            case 6002:
              if (path != "/transition") {
                if (toUrl) {
                  window.location.href = decodeURIComponent(toUrl);
                } else {
                  Utils.redirect("/");
                }
              }
              break;
            //1010 待支付
            case 1010:
              // Utils.redirect("/pay");
              break;
            //用户已支付
            // 1000调用成功标识，全局统一；
            case 6008:
            case 1000:
            case 3001:
              break;

            // 内部系统错误，或标识数据验证失败
            case 3333:
              if (path == "/initPage") {
                break;
              }
              if (_data.Msg !== "该订单已失效不存在") {
                VUE.$message.error({ message: _data.Msg, customClass: "errorMessage" });
              }
              break;

            default:
              VUE.$message.error({ message: _data.Msg, customClass: "errorMessage" });
          }
        }
      }
    }
    return _data;
  },
  err => {
    if (err.response) {
      const { path } = VUE.$route;
      switch (err.response.status) {
        case 400:
          break;
        case 401: {
          if (path == "/initPage") {
            Cookies.remove("wqExpertToken");
          } else {
            Cookies.remove("wqToken");
          }
          break;
        }
        case 405:
        case 500:
        default:
          // if (err.response.data && err.response.data.message) {
          //   window.Vue.$message.error(err.response.data.message)
          // } else {
          //   window.Vue.$message.error('服务器错误')
          // }
          break;
      }
    }
    return err.response;
  },
);

export default _axios;
